module.exports = __webpack_public_path__ + "static/6-01407c0d59e6ca44c8c2f4beb0b964d2.svg";